import { createSelector } from 'reselect';
import _ from 'lodash';

/**
 * analyticsSelector
 * Selector for the analytics state.
 * @param { Object } state: The application state.
 * @returns { Object } The analytics state.
 */
export const analyticsSelector = (state) => state.analytics;

/**
 * createAnalyticsSelector
 * Creates a selector for the analytics state of a given attribute.
 * @param { String } attr: The attribute of the state to create a selector of.
 * @param { Any } defaultValue: The default value if value does not exist.
 * @returns { Object } The selected state.
 */
export const createAnalyticsSelector = (attr, defaultValue) =>
  createSelector(analyticsSelector, (analytics) => analytics[attr] || defaultValue);

/**
 * Selectors for the analytics state.
 * @param { Object } state: The application state.
 * @returns { Any } The value of the determined analytics state.
 */
export const selectUserMappings = createAnalyticsSelector('userMappings', []);

export const selectUserMappingsByType = createSelector([selectUserMappings], (mappings) => {
  const userMappings = {};
  mappings.forEach(({ name, type }) => {
    if (!userMappings[type]) {
      userMappings[type] = [];
    }
    userMappings[type].push({ text: name, value: name });
  });

  _.keys(userMappings).forEach((key) => {
    userMappings[key] = _.sortBy(userMappings[key], ['text']);
  });

  return userMappings;
});
